import { render, staticRenderFns } from "./viewStaffInfo.vue?vue&type=template&id=5c03b4c1&scoped=true"
import script from "./viewStaffInfo.vue?vue&type=script&lang=js"
export * from "./viewStaffInfo.vue?vue&type=script&lang=js"
import style0 from "./viewStaffInfo.vue?vue&type=style&index=0&id=5c03b4c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c03b4c1",
  null
  
)

export default component.exports